//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Debounce from "lodash.debounce";
export default {
    props: {
        title: {
            type: String,
            default: "",
        },
        type: {
            type: String,
            default: "",
        },
        value: [String, Number],
        placeholder: String,
        // showClear: {
        //   type: Boolean,
        //   default() {
        //     return true
        //   }
        // },
        debounce: Number,
        max: Number,
        labelWidth: {
            type: String,
            default: "4em",
        },
        showBorder: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        bindType: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            old_value: "",
            showClear: false,
        };
    },
    mounted() {
        if (this.debounce) {
            this._debounce = Debounce(() => {
                this.$emit("on-change", this.currentValue);
            }, this.debounce);
        }
        this.input = this.$refs.input;
        if (this.value) {
            this.input.value = this.value;
            this.inputChange();
        }
    },
    methods: {
        inputChange() {
            let input = this.input;
            let start = input.selectionStart;
            if (this.type === "tel") {
                const reg = this.bindType === "auto"
                    ? /(\d{3})(\*{0,4})(\d{0,4})/
                    : /(\d{3})(\d{0,4})(\d{0,4})/;
                input.value = input.value
                    .replace(/\s/g, "")
                    .replace(reg, "$1 $2 $3");
            } else if (this.type === "cardnum") {
                let reg = input.value.includes("*")
                    ? /(\d{4})(\*{0,4})(\*{0,4})(\*{0,4})(\d{0,4})/
                    : /(\d{4})(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})/;
                input.value = input.value
                    .replace(/\s/g, "")
                    .replace(reg, "$1 $2 $3 $4 $5");
            } else {
            }

            if (input.value.substr(input.value.length - 1) == " ") {
                input.value = input.value.substr(0, input.value.length - 1);
            }
            if (this.old_value.length < input.value.length) {
                if (this.type === "tel") {
                    switch (start) {
                        case 4:
                            start += 1;
                            break;
                        case 9:
                            start += 1;
                            break;
                    }
                } else if (this.type === "cardnum") {
                    switch (start) {
                        case 5:
                            start += 1;
                            break;
                        case 10:
                            start += 1;
                            break;
                        case 15:
                            start += 1;
                            break;
                        case 20:
                            start += 1;
                            break;
                    }
                } else {
                }
            }
            setTimeout(() => {
                input.selectionStart = start;
                input.selectionEnd = start;
            }, 10);

            this.old_value = input.value;
        },
        clear() {
            this.input.value = "";
            this.old_value = "";
            this.input.focus();
            this.$emit("on-click-clear-icon");
        },
        focus() {
            if (this.input.value) {
                this.showClear = true;
            } else {
                this.showClear = false;
            }
        },
        blur() {
            setTimeout(() => {
                this.showClear = false;
            }, 0);
        },
        // onBlur($event) {
        //   setTimeout(() => {
        //     this.isFocus = false
        //   }, 0)
        //   this.$emit('on-blur', this.currentValue, $event)
        // },
        // focusHandler($event) {
        //   this.$emit('on-focus', this.currentValue, $event)
        //   this.isFocus = true
        //   // setTimeout(() => {
        //   //   this.$refs.input.scrollIntoViewIfNeeded(false)
        //   // }, 1000)
        // },
        // scrollIntoView(time = 0) {
        //   if (
        //     document.activeElement.tagName === 'INPUT' ||
        //     document.activeElement.tagName === 'TEXTAREA'
        //   ) {
        //     setTimeout(() => {
        //       this.$refs.input.scrollIntoViewIfNeeded(true)
        //     }, time)
        //   }
        // },
        // maskValue(val) {
        //   const val1 = this.mask ? mask.toPattern(val, this.mask) : val
        //   return val1
        // }
    },
    watch: {
        old_value(val) {
            this.$emit("input", val);
            this.showClear = !!val;

            if (this._debounce) {
                this._debounce();
            } else {
                this.$emit("on-change", val);
            }
        },
        value() {
            if (this.type === "cardnum" || this.type === 'tel') {
                this.input.value = this.value;
                this.inputChange();
            }
        },
        // currentValue(newVal) {
        //   setTimeout(() => {
        //     this.$emit('input', this.maskValue(newVal))
        //   }, 0)
        //   if (this._debounce) {
        //     this._debounce()
        //   } else {
        //     this.$emit('on-change', newVal)
        //   }
        // }
    },
};
